const discoverImage = document.querySelector('.product-drive-discover-image');
const driveVideoPlayerInCar = document.getElementById('drive-video-player-in-car');
const driveVideoPlayerWorking = document.getElementById('drive-video-player-working');
const productDriveInterfere = document.querySelector('.product-drive-interfere');
const videoOffset = 300;

document.addEventListener('DOMContentLoaded', () => {
    setVideoSrc();
});

window.addEventListener("resize", resizeThrottler, false);

var resizeTimeout;
function resizeThrottler() {
    if ( !resizeTimeout ) {
        resizeTimeout = setTimeout(function() {
            resizeTimeout = null;
            setVideoSrc();
        }, 500);
    }
}

  

if(driveVideoPlayerInCar){
    driveVideoPlayerInCar.addEventListener('click', (e) => {
        if(!driveVideoPlayerInCar.classList.contains('paused')){
            driveVideoPlayerInCar.classList.add('paused')
            driveVideoPlayerInCar.pause()
        }else{
            driveVideoPlayerInCar.classList.remove('paused')
            driveVideoPlayerInCar.play()
        }
    });

    let driveVideoPlayerInCarDescription1 = document.getElementById('player-in-car-description-1');
    let driveVideoPlayerInCarDescription2 = document.getElementById('player-in-car-description-2');
    let driveVideoPlayerInCarDescription1Spans = driveVideoPlayerInCarDescription1.querySelectorAll('span');
    let driveVideoPlayerInCarDescription2Spans = driveVideoPlayerInCarDescription2.querySelectorAll('span');
    let timeToChangeInCar = 5;
    let bounceInterval = 150;
    driveVideoPlayerInCar.addEventListener("timeupdate", (event) => {
        if(!driveVideoPlayerInCar.paused){
            if(driveVideoPlayerInCar.currentTime > timeToChangeInCar ){
                driveVideoPlayerInCarDescription1.classList.remove('active');
                driveVideoPlayerInCarDescription2.classList.add('active');
                driveVideoPlayerInCarDescription1Spans.forEach( el => el.classList.remove('bounce-up') );
                driveVideoPlayerInCarDescription2Spans.forEach(function (item, index) {
                    setTimeout(function () {
                        item.classList.add('bounce-up');
                    }, index * bounceInterval);
                });
            }else{
                driveVideoPlayerInCarDescription1.classList.add('active');
                driveVideoPlayerInCarDescription2.classList.remove('active');
                driveVideoPlayerInCarDescription2Spans.forEach( el => el.classList.remove('bounce-up') );
                driveVideoPlayerInCarDescription1Spans.forEach(function (item, index) {
                    setTimeout(function () {
                        item.classList.add('bounce-up');
                    }, index * bounceInterval);
                });
            }
        }
    });
}

if(driveVideoPlayerWorking){
    driveVideoPlayerWorking.addEventListener('click', (e) => {
        if(!driveVideoPlayerWorking.classList.contains('paused')){
            driveVideoPlayerWorking.classList.add('paused')
            driveVideoPlayerWorking.pause()
        }else{
            driveVideoPlayerWorking.classList.remove('paused')
            driveVideoPlayerWorking.play()
        }
    });

    let driveVideoPlayerWorkingDescription1 = document.getElementById('player-working-description-1');
    let driveVideoPlayerWorkingDescription2 = document.getElementById('player-working-description-2');
    let timeToChangeWorking = 3;
    let driveVideoPlayerWorkingDescription1Spans = driveVideoPlayerWorkingDescription1.querySelectorAll('span');
    let driveVideoPlayerWorkingDescription2Spans = driveVideoPlayerWorkingDescription2.querySelectorAll('span');
    let bounceInterval = 150;

    driveVideoPlayerWorking.addEventListener("timeupdate", (event) => {
        if(!driveVideoPlayerWorking.paused){
            if(driveVideoPlayerWorking.currentTime > timeToChangeWorking ){
                driveVideoPlayerWorkingDescription1.classList.remove('active');
                driveVideoPlayerWorkingDescription2.classList.add('active');
                driveVideoPlayerWorkingDescription1Spans.forEach( el => el.classList.remove('bounce-up') );
                driveVideoPlayerWorkingDescription2Spans.forEach(function (item, index) {
                    setTimeout(function () {
                        item.classList.add('bounce-up');
                    }, index * bounceInterval);
                });
            }else{
                driveVideoPlayerWorkingDescription1.classList.add('active');
                driveVideoPlayerWorkingDescription2.classList.remove('active');
                driveVideoPlayerWorkingDescription2Spans.forEach( el => el.classList.remove('bounce-up') );
                driveVideoPlayerWorkingDescription1Spans.forEach(function (item, index) {
                    setTimeout(function () {
                        item.classList.add('bounce-up');
                    }, index * bounceInterval);
                });
            }
        }
    });
}


document.addEventListener("scroll", (e)=>{
    
    if(iSinViewport(discoverImage, 200)){
        discoverImage.classList.add('illuminated');
    }else{
        discoverImage.classList.remove('illuminated');
    }

    if(iSinViewport(driveVideoPlayerInCar, videoOffset)){
        if(!driveVideoPlayerInCar.classList.contains('paused') && driveVideoPlayerInCar.paused){
            console.log('InCar');
            driveVideoPlayerInCar.play();
        }
    }
    if(iSinViewport(driveVideoPlayerWorking, videoOffset)){
        if(!driveVideoPlayerWorking.classList.contains('paused') && driveVideoPlayerWorking.paused){
            console.log('Working');
            driveVideoPlayerWorking.play();
        }
    }
    if(iSinViewport(productDriveInterfere, 400)){
        productDriveInterfere.classList.add('activated')
    }else{
        productDriveInterfere.classList.remove('activated')
    }
});


const iSinViewport = (elem, offset = 0) => {
    let windowHeight = window.innerHeight;
    let viewportOffset = elem.getBoundingClientRect(); 
    let top = viewportOffset.top + offset; 
    let btm = viewportOffset.bottom - offset; 
    
    if(top < windowHeight){ 
        return true;
    } else{
        return false;
    }
}

function setVideoSrc(){
    let mobileWidth = 480;
    const videos = document.querySelectorAll('video')
    if(videos){
        videos.forEach((video) => {
            let mobileSrc = video.dataset.mobileSrc
            let desktopSrc = video.dataset.desktopSrc
            if(mobileSrc !== undefined && desktopSrc !== undefined){
                if( window.innerWidth <= mobileWidth ){
                    // mobile
                    video.pause();
                    video.src = mobileSrc;
                    if(iSinViewport(video, videoOffset)){
                        video.play();
                    }
                    console.log('set to mobile');
                }else{
                    // desktop
                    video.pause();
                    video.src = desktopSrc;
                    if(iSinViewport(video, videoOffset)){
                        video.play();
                    }
                    console.log('set to desktop');
                }
            }
        })
    }
}



const popupZoomInner = document.querySelector('.popup-zoom-inner img')
if(popupZoomInner){
    let aspect = 1
    let imageWidth
    let windowWidth
    popupStarter = document.querySelector('.l2-wib-image-wrp-mobile')
    popupStarter.addEventListener('click', (e) => {
        imageWidth = popupZoomInner.getBoundingClientRect().width
        windowWidth = window.innerWidth
    })
    
    let clientX;
    let clientY;
    popupZoomInner.addEventListener("touchstart", (e) => {
            clientX = e.touches[0].clientX;
            clientY = e.touches[0].clientY;
    }, false, );
    
    popupZoomInner.addEventListener('touchmove', function (e) {
        let deltaX = e.changedTouches[0].clientX - clientX;
        let style = window.getComputedStyle(popupZoomInner)
        let transform = new WebKitCSSMatrix(style.transform).m41
        let newTransform = transform + deltaX * aspect
        if( Math.abs( newTransform ) < (imageWidth - windowWidth) / 2 ){
            popupZoomInner.style.transform = "translateX(" + newTransform + "px)";    
        }
        
    })
   
}


// first block

const productQuantityRetailItems = document.querySelectorAll('.product-quantity-retail-item')
productQuantityRetailItems.forEach((item) => {
    item.addEventListener('click', (e) => {
        if(!item.classList.contains('active')){
            productQuantityRetailItems.forEach((el) => {
                el.classList.remove('active')
            })
            item.classList.add('active')
            if (typeof setStickyButton === "function") {
                setStickyButton(item)
            }
        }
    })
})

const productQuantitySelection = document.querySelector('.product-quantity-selection')
const productSetBulkButton = document.querySelector('.product-quantity-set-bulk')
const productSetretailButton = document.querySelector('.product-quantity-set-retail')
const productRetail = document.querySelector('.product-quantity-retail')
const productBulk = document.querySelector('.product-quantity-bulk')
productSetBulkButton.addEventListener('click', (e) => {
    $(productRetail).slideUp()
    $(productBulk).slideDown()
    productQuantitySelection.classList.add('bulk')
    if (typeof setStickyButtonMode === "function") {
        setStickyButtonMode('bulk')
    }
})
productSetretailButton.addEventListener('click', (e) => {
    $(productRetail).slideDown()
    $(productBulk).slideUp()
    productQuantitySelection.classList.remove('bulk')
    if (typeof setStickyButtonMode === "function") {
        setStickyButtonMode('retail')
    }
})



const l2UsersSwiper = new Swiper("#l2-users-swiper", {
    spaceBetween: 0,
    slidesPerView: 1,
    pagination: {
        el: ".users-swiper-pagination",
    },
    breakpoints: {
        1100: {
            slidesPerView: 3,
        },
        800: {
            slidesPerView: 2,
        },
    },
})

const swiperHintLottie = document.getElementById('swiper-hint-lottie');
const productSliderThumb = new Swiper(".product-slider-thumbnails", {
    spaceBetween: 8,
    slidesPerView: 6,
    freeMode: true,
    watchSlidesProgress: true,
    breakpoints: {
      900: {
        spaceBetween: 10,
        slidesPerView: 7,
        allowTouchMove: false,
      },
    }
});

//const effectsBanner = document.querySelector('.effects-banner')
const productSlider = new Swiper(".product-slider", {
    effect: 'fade',
    allowTouchMove: true,
    loop: true,
    fadeEffect: {
      crossFade: true
    },
    thumbs: {
        swiper: productSliderThumb,
    },
    breakpoints: {
        1100: {
            navigation: {
            nextEl: ".product-swiper-button-next",
            prevEl: ".product-swiper-button-prev",
            },
        },
    },
    on: {
        slideChange: function () {
            swiperHintLottie.stop();
            console.log('stoped');
        }
    }
});


// const wibButton = document.querySelector('.product-whats-in-the-box-button')
// const wibPopup = document.querySelector('.product-whats-in-the-box-popup')
// wibButton.addEventListener('click', (e) => {
//     wibPopup.classList.toggle('open')
// })

// document.addEventListener('click', (e) => {
//     if( e.target != wibButton && !e.target.closest('.product-whats-in-the-box-popup') ){ 
//         wibPopup.classList.remove('open')
//     }
// })


const productBulkQtMinusButton = document.querySelector('.product-quantity-bulk-minus')
const productBulkQtPlusButton = document.querySelector('.product-quantity-bulk-plus')
const productQuantityBulkInput = document.querySelector('.product-quantity-bulk-input')
const productQuantityBulkUnitsCount = document.querySelector('.product-quantity-bulk-units-qt')
const productQuantityBulkUnitsDiscountBadge = document.querySelector('.product-quantity-bulk-units-discount-badge')
const productQuantityBulkUnitPriceValue = document.querySelector('.product-quantity-bulk-unit-price-value')
const productQuantityBulkItemPrice = document.querySelector('.product-quantity-bulk-item-price')
const productAddToCartButtons = document.querySelectorAll('.product-item-add-to-cart')
const productQuantityBulkUnitPriceValueOriginal = document.querySelector('.product-quantity-bulk-unit-price-per-unit-original')
const productQuantityBulkBadgeProfit = document.querySelector('.product-quantity-bulk-badge-profit')

productBulkQtMinusButton.addEventListener('click', (e) => {
    let inputValue = parseInt(productQuantityBulkInput.value)
    if( inputValue > 4 ){
        inputValue--
        productQuantityBulkInput.value = inputValue
    }else{
        productBulkQtMinusButton.disabled = true
    }
    setProductQuantityBulk()
})

productBulkQtPlusButton.addEventListener('click', (e) => {
    let inputValue = parseInt(productQuantityBulkInput.value) + 1
    productQuantityBulkInput.value = inputValue
    if(inputValue > 4){
        productBulkQtMinusButton.disabled = false
    }
    setProductQuantityBulk()
})

productAddToCartButtons.forEach((productAddToCartButton) => {
    productAddToCartButton.addEventListener('click', (e) => {
        let currentProductEl = document.getElementById('product-drive')
        const cartSidebar = document.getElementById('cart-sidebar')
        const l2BulkInput = document.getElementById('drive-bulk-variation')
        if( currentProductEl !== null ){
            addProduct(currentProductEl)
            cartSidebar.classList.add('step-2')
            let productQuantity = 1
            if(productQuantitySelection.classList.contains('bulk')){
                productQuantity = productQuantityBulkInput.value
                
                l2BulkInput.value = productQuantity

                setBulkMode(currentProductEl, true)
                bulkImageVariant(currentProductEl)
                setUnitsQuantity()
                
            }else{
                setBulkMode(currentProductEl, false)
                let curSelectedRetailQuantityEl = document.querySelector('.product-quantity-retail-item.active')
                if(curSelectedRetailQuantityEl){
                    productQuantity = curSelectedRetailQuantityEl.dataset.productQuantity
                }
                let curActive = currentProductEl.querySelector('.item-variation.active')
                if(curActive){
                    curActive.classList.remove('active')
                }
                currentProductEl.querySelector('.item-variation[data-quantity="'+productQuantity+'"]').classList.add('active')
                setUnitsQuantity()
                
            }

            toggleMinimized(currentProductEl, false)
            
            changeColorVariationImage(currentProductEl)
            saveState()
            discounts()
            
            window.setTimeout(function(){
                document.body.classList.add('sidebar-open')
            }, 200);

            if(productAddToCartButton.classList.contains('sticky-button-el')){
                e.stopPropagation()
            }
        }
    })
})


function setProductQuantityBulk(){
    let quantity = parseInt(productQuantityBulkInput.value)
    productQuantityBulkUnitsCount.innerHTML = quantity
    let curDiscountAmount = null
    if(quantity <= 24){
        curDiscountAmount = productDiscountAmounts[quantity]
    }else{
        curDiscountAmount = productDiscountAmounts[24]
    }
    productQuantityBulkUnitsDiscountBadge.innerHTML = '-'+curDiscountAmount+'%'
    let basePrice = parseInt(productQuantityBulkItemPrice.dataset.basePrice)
    let pricePerUnit = parseInt( basePrice * ( 100 - curDiscountAmount ) / 100 )
    let priceTotal = parseInt( basePrice * quantity * ( 100 - curDiscountAmount ) / 100 )
    productQuantityBulkItemPrice.innerHTML = getPromotionalPrice(priceTotal).toFixed()
    productQuantityBulkUnitPriceValue.innerHTML = getPromotionalPrice(pricePerUnit).toFixed()

    let profit = basePrice * quantity - priceTotal
    productQuantityBulkBadgeProfit.innerHTML = profit

    if(productQuantityBulkUnitPriceValueOriginal){
        productQuantityBulkUnitPriceValueOriginal.innerHTML = priceTotal.toFixed()
    }
    if (typeof setStickyButtonBulk === "function") {
        setStickyButtonBulk()
    }
    
}
